import React from 'react';
import SectionHeader from '../common/SectionHeader';
import InfoHintButton from '../common/InfoHintButton';
import { SESSION_PANEL_SURFACE } from '../../utils/sessionMobileLayout';

/**
 * Collapsible block for host admin sections (match settings, scheduled, partnerships, players).
 * Controlled expanded state for persistence from parent.
 * Expanded content sits in the same surface panel as Player Management unless `panel` is false
 * (used when children already provide that panel).
 */
export default function HostAdminCollapsibleSection({
  id,
  title,
  variant = 'default',
  infoText,
  infoAriaLabel,
  expanded,
  onExpandedChange,
  children,
  className = '',
  panel = true,
}) {
  return (
    <section id={id} className={`scroll-mt-28 ${className}`.trim()}>
      <button
        type="button"
        onClick={() => onExpandedChange(!expanded)}
        className="flex w-full items-center justify-between gap-3 rounded-lg py-1 text-left transition hover:bg-surface-subtle/50"
        aria-expanded={expanded}
      >
        <div className="min-w-0 flex-1 flex items-center gap-0.5">
          <SectionHeader title={title} variant={variant} className="min-w-0 flex-1 pointer-events-none" />
          {infoText ? (
            <InfoHintButton
              text={infoText}
              ariaLabel={infoAriaLabel}
              className="h-6 w-6 shrink-0"
            />
          ) : null}
        </div>
        <svg
          className={`h-5 w-5 shrink-0 text-text-secondary transition-transform duration-200 ${
            expanded ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <hr className="mb-4 mt-1 border-t border-border-medium" />
      {expanded ? (
        <div className={panel ? SESSION_PANEL_SURFACE : undefined}>{children}</div>
      ) : null}
    </section>
  );
}
